import React from 'react';
import { MdInfo, MdClose } from 'react-icons/md';

interface NotificationBannerProps {
  message: string | JSX.Element;  
  onClose: () => void; 
  canIgnore: boolean;
}

const NotificationBanner: React.FC<NotificationBannerProps> = ({
  message,
  onClose,
  canIgnore,
}) => {

  return (
    <div className="py-2 bg-negative-red text-white text-sm font-medium text-center relative flex items-center justify-center gap-2">
      <MdInfo className="text-white w-4 h-4 rotate-180" />
      <div>
        {message}
        {canIgnore && (
          <button
            type="button"
            className="bg-transparent w-4 h-4 rounded-full cursor-pointer absolute right-2 top-1"
            onClick={onClose}
          >
            <MdClose className="text-white w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default NotificationBanner;
